<div>
  <div class="mb-4 border-b border-gray-200 px-2">
    <ul class="tabs pl-12 flex -mb-px text-sm font-medium text-center list-none overflow-auto whitespace-nowrap"
        id="myTab"
        data-tabs-toggle="#myTabContent"
        role="tablist">
      <li class="mr-12" role="presentation" *ngFor="let tab of tabs">
        <button
          class="inline-block p-4 rounded-t-lg text-color-sun-yellow transition ease-in-out duration-200"
          type="button"
          aria-selected="false"
          [ngClass]="{'border-sun-yellow font-bold border-b-[6px]': tab.active, 'border-yellow2 font-medium border-b-4': !tab.active }"
          (click)="selectTab(tab)">
          {{tab.tabTitle}}
        </button>
      </li>
    </ul>
  </div>
  <ng-content></ng-content>
</div>
